/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function WarningSmall2(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'WarningSmall2',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 12 * scale,
      viewBox: '0 0 16 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"m14.195 9.734-5.39-8.468c-.443-.696-1.168-.696-1.61 0l-5.39 8.468C1.362 10.43 1.675 11 2.5 11h11c.825 0 1.138-.57.695-1.266M8 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2m.502-3H7.498L7 3h2z"}))
}
